import React, { useState, useMemo, useEffect } from "react";
import {
  breakfastIcon,
  breakfastWhiteIcon,
  lunchIcon,
  lunchWhiteIcon,
  dinnerIcon,
  dinnerWhiteIcon,
  otherIcon,
  otherWhiteIcon,
} from "assets/img";
import classNames from "classnames";

const MealSeries = ({ handleMealChange, mealSelected }) => {
  const isOtherSelected = useMemo(
    () => mealSelected.meal === "other",
    [mealSelected]
  );

  const isBreakfastSelected = useMemo(
    () => mealSelected.meal === "breakfast",
    [mealSelected]
  );

  const isLunchSelected = useMemo(
    () => mealSelected.meal === "lunch",
    [mealSelected]
  );

  const isDinnerSelected = useMemo(
    () => mealSelected.meal === "dinner",
    [mealSelected]
  );

  const [breakfastHover, setBreakfastHover] = useState(false);
  const [lunchHover, setLunchHover] = useState(false);
  const [dinnerHover, setDinnerHover] = useState(false);
  const [otherHover, setOtherHover] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(true);

  useEffect(() => {
    setIsLargeScreen(window.innerWidth >= 1024);
  });

  const otherImageSource =
    mealSelected.meal === "other" || (otherHover && isLargeScreen)
      ? otherWhiteIcon
      : otherIcon;

  const dinnerImageSource =
    mealSelected.meal === "dinner" || (dinnerHover && isLargeScreen)
      ? dinnerWhiteIcon
      : dinnerIcon;

  const lunchImageSource =
    mealSelected.meal === "lunch" || (lunchHover && isLargeScreen)
      ? lunchWhiteIcon
      : lunchIcon;

  const breakfastImageSource =
    mealSelected.meal === "breakfast" || (breakfastHover && isLargeScreen)
      ? breakfastWhiteIcon
      : breakfastIcon;

  return (
    <>
      <div className="inline-flex screen-md:flex screen-lg:flex gap-6 py-4">
        <div
          className={classNames(
            "w-1/2 screen-md:w-32 screen-lg:w-32 px-6 pb-3 rounded-xl text-slate-700 font-inter-medium leading-tight text-center hover:cursor-pointer",
            {
              "bg-indigo-500 text-white": isBreakfastSelected,
              "bg-slate-50 screen-lg:hover:bg-indigo-500 screen-lg:hover:text-white":
                !isBreakfastSelected,
            }
          )}
          onClick={() => handleMealChange("breakfast")}
          onMouseEnter={() => setBreakfastHover(true)}
          onMouseLeave={() => setBreakfastHover(false)}
        >
          <img src={breakfastImageSource} alt="Breakfast" />
          Breakfast
        </div>

        <div
          className={classNames(
            "w-1/2 screen-md:w-32 screen-lg:w-32 px-6 pb-3 rounded-xl text-slate-700 font-inter-medium leading-tight text-center hover:cursor-pointer",
            {
              "bg-indigo-500 text-white": isLunchSelected,
              "bg-slate-50 screen-lg:hover:bg-indigo-500 screen-lg:hover:text-white":
                !isLunchSelected,
            }
          )}
          onClick={() => handleMealChange("lunch")}
          onMouseEnter={() => setLunchHover(true)}
          onMouseLeave={() => setLunchHover(false)}
        >
          <img src={lunchImageSource} alt="Lunch" />
          Lunch
        </div>
      </div>

      <div className="inline-flex screen-md:flex screen-lg:flex gap-6 py-4">
        <div
          className={classNames(
            "w-1/2 screen-md:w-32 screen-lg:w-32 px-6 pb-3 rounded-xl text-slate-700 font-inter-medium leading-tight text-center hover:cursor-pointer",
            {
              "bg-indigo-500 text-white": isDinnerSelected,
              "bg-slate-50 screen-lg:hover:bg-indigo-500 screen-lg:hover:text-white":
                !isDinnerSelected,
            }
          )}
          onClick={() => handleMealChange("dinner")}
          onMouseEnter={() => setDinnerHover(true)}
          onMouseLeave={() => setDinnerHover(false)}
        >
          <img src={dinnerImageSource} alt="Dinner" />
          Dinner
        </div>

        <div
          className={classNames(
            "w-1/2 screen-md:w-32 screen-lg:w-32 px-6 pb-3 rounded-xl text-slate-700 font-inter-medium leading-tight text-center hover:cursor-pointer ",
            {
              "bg-indigo-500 text-white": isOtherSelected,
              "bg-slate-50 screen-lg:hover:bg-indigo-500 screen-lg:hover:text-white":
                !isOtherSelected,
            }
          )}
          onClick={() => handleMealChange("other")}
          onMouseEnter={() => setOtherHover(true)}
          onMouseLeave={() => setOtherHover(false)}
        >
          <img src={otherImageSource} alt="Other" />
          Other
        </div>
      </div>
    </>
  );
};

export default MealSeries;
